export default {"src":"/_next/static/media/outlet-top-banner.e975a72c.svg","height":180,"width":280,"blurWidth":0,"blurHeight":0};